import parse, { DOMNode, Element, domToReact } from 'html-react-parser';
import React, { useEffect, useState } from 'react';

import { SuggestedAiPromptIconProps } from './interfaces';

const SuggestedAiPromptIcon = ({ disablePrompts, promptUrl }: SuggestedAiPromptIconProps) => {
  const [svgContent, setSvgContent] = useState<string | null>(null);

  const className = `transition-colors flex-shrink-0 ${
    disablePrompts
      ? 'text-grayscale-gray'
      : 'text-grayscale-charcoal group-hover/prompt:text-primary-magenta'
  }`;

  useEffect(() => {
    fetch(promptUrl)
      .then((res) => res.text())
      .then((text) => {
        // Remove all fill="..." attributes everywhere
        const cleaned = text.replace(/fill=".*?"/g, '');
        setSvgContent(cleaned);
      })
      .catch((err) => console.error('Error loading SVG:', err));
  }, [promptUrl]);

  if (!svgContent) return null;

  return parse(svgContent, {
    replace: (domNode) => {
      // rewrite top level svg node and embed as React
      if (domNode instanceof Element && domNode.name === 'svg') {
        const attribs = { ...domNode.attribs };
        delete attribs.class;

        return (
          <svg {...attribs} height={17} className={className} fill="currentColor">
            {domToReact(domNode.children as unknown as DOMNode[])}
          </svg>
        );
      }
    },
  }) as unknown as JSX.Element;
};

export default SuggestedAiPromptIcon;
